<template>
  <div class="home div-100">
    <Banner :height="521" v-bind:path="'banner.png'" />

    <v-container
      v-if="this.$store.getters['notification/roomState'] === 'done'"
    >
      <v-card flat color="transparent">
        <v-card-subtitle>
          <h1 class="event-subtitle" v-html="$t('page.pause.text')"></h1>
          <a class="event-date" :href="`mailto:${$t('page.pause.help')}`">{{
            $t("page.pause.help")
          }}</a>
        </v-card-subtitle>
      </v-card>
    </v-container> 

    <v-container v-else>
      <v-card flat color="transparent">
        <v-card-title>
          <h1 class="event-title primary--text">
            {{ $t("event.title") }}
          </h1>
        </v-card-title>

        <v-card-subtitle class="d-flex flex-column flex-sm-row">
          <h1
            class="event-subtitle my-auto py-0"
            v-html="$t('event.subtitle')"
          ></h1>

          <v-card-actions
            class="d-flex ma-3 ma-lg-4 pa-0 flex-grow-1 align-center justify-start justify-sm-end"
            
          >
          <!-- v-if="activeAgenda" -->
            <v-btn              
              color="accent"
              append
              :to="{
                name: 'WaitingRoom',
                params: { eventid: this.$store.state.event_id },
              }"
              large
              class="px-5 ma-3"
            >
              {{ $t("home.btn_enter") }}
              <img
                class="ml-2"
                height="20"
                :src="require('_shared/assets/spk__arrow-right.svg')"
              />
            </v-btn>
          </v-card-actions>
        </v-card-subtitle>

        <v-card-text>
          <p class="event-date" v-html="$t('event.date')"></p>
          <p v-html="$t('event.description.text')"></p>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Banner from "_shared/components/Banner";
import { urlHelper } from "_shared/helpers";

export default {
  name: "Event",
  components: {
    Banner,
  },
  mixins: [urlHelper],
  data: () => ({
    EventItem: { eventMetaInfo: {} },
  }),  
  async created() {
    this.EventItem = await this.$store.dispatch("getEventItems");    
  },
};
</script>


<style lang="scss" scoped>
.event-title {
  font-family: "Head";
  font-size: 36px;
  line-height: 1;
  padding-bottom: 24px;
}
.event-subtitle {
  font-family: "Bold";
  font-size: 28px;
  padding-bottom: 16px;
  line-height: 2rem;
}
.event-date {
  font-family: "Bold";
  font-size: 18px;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .event-title {
    font-size: 36px;
  }
  .event-subtitle {
    font-size: 18px;
    line-height: initial;
  }
  .event-date {
    font-size: initial;
  }
}
</style>